import moment from 'moment-timezone';

const TZ = 'America/Bogota';

export type MinimalAuthUserForSuperAdmin = {
  is_system?: number | null;
  username?: string | null;
} | null;

/** Alineado con API `isSuperAdminUser`: sistema o cuenta `superadmin`. */
export function isWebSuperAdminPrincipal(
  authUserData: MinimalAuthUserForSuperAdmin,
): boolean {
  return (
    Number(authUserData?.is_system ?? 0) === 1 ||
    String(authUserData?.username ?? '').toLowerCase() === 'superadmin'
  );
}

/** Misma regla que API: hoy cualquiera con permiso; superadmin hasta 30 días hacia atrás (fecha operativa). */
export function isOperationalDateEligibleForPayDelete(params: {
  payDateYmd: string | null | undefined;
  todayYmd: string;
  superAdmin: boolean;
}): boolean {
  const { payDateYmd, todayYmd, superAdmin } = params;
  if (!payDateYmd) {
    return false;
  }

  const pay = moment.tz(payDateYmd, 'YYYY-MM-DD', TZ).startOf('day');
  const today = moment.tz(todayYmd, 'YYYY-MM-DD', TZ).startOf('day');
  if (!pay.isValid() || !today.isValid()) {
    return false;
  }

  const diff = today.diff(pay, 'days');
  if (diff < 0) {
    return false;
  }
  if (diff === 0) {
    return true;
  }
  return superAdmin && diff <= 29;
}
